import { search } from '../../Foundation';

export class ProductSearch {
  /**
   * Creates an instance where user can search for products
   * @param {HTMLElement} element - component
   */
  constructor(element) {
    // Name, reference
    element.ProductSearch = this;

    // Elements
    this._refs = {
      input: element.querySelector('input[type="text"]'),
      button: element.querySelector('i'),
      filters: Array.from(document.querySelectorAll('.product-filter .form-select select')),
      category: document.querySelector('.selectedNode a'),
    };

    // Events
    if (this._refs.input != null) {
      this._refs.input.addEventListener('keydown', this._onKeyDown.bind(this));
    }

    if (this._refs.button != null) {
      this._refs.button.addEventListener('click', this._onButtonClick.bind(this));
    }
  }

  get searchQuery() {
    localStorage.setItem('scrollposition', 'search');

    return {
      phrase: this._refs.input.value,
      category:
        this._refs.category != null
          ? this._refs.category.getAttribute('href').replace('javascript:', '').replace(':', '!')
          : '',
      filters: this._refs.filters,
    };
  }

  /**
   * onButtonClick
   * When user clicks on the "search" icon
   */
  _onButtonClick() {
    search.execute(this.searchQuery);
  }

  /**
   * onKeyDown
   * Execute a search when user presses enter
   * @param {Event} e - event interface
   */
  _onKeyDown(e) {
    let charCode = e.which ? e.which : e.keyCode;
    if (charCode == 13) {
      e.preventDefault();
      search.execute(this.searchQuery);
    }
  }
}
